import { PageContext } from 'hooks/shared/usePageContext.types';
import { GlobalDialogType } from 'stores/global-dialogs/global-dialogs.store.types';
import { CENTRAL_INBOX_DIALOG_KEY, RATED_CANDIDATES_DIALOG_KEY, SHARED_CANDIDATE_DIALOG_KEY } from './constants';

export const getDialogKeyByPageContext = (
  type: GlobalDialogType,
  pageContext: PageContext,
  fallbackKey: string,
): string => {
  switch (pageContext) {
    case PageContext.RatedCandidates:
      return RATED_CANDIDATES_DIALOG_KEY;
    case PageContext.Shared:
    case PageContext.Candidate:
      return SHARED_CANDIDATE_DIALOG_KEY;
    case PageContext.CentralInbox:
      return CENTRAL_INBOX_DIALOG_KEY;
    default:
      return fallbackKey;
  }
};
